import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translation_en from "./translations/en/translation.json";
import translation_vi from "./translations/vi/translation.json";

const language = sessionStorage.getItem("language") || "en";

const resources = {
  en: { translation: translation_en },
  vi: { translation: translation_vi },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
    },
  });

export default i18n;
